import type { LocaleLoaders } from '@wegic/i18n-core';
import { I18nLanguage } from '@wegic/i18n-core';

/**
 * Login 包的 i18n 命名空间
 */
export const LOGIN_I18N_NAMESPACE = 'login';

/**
 * Login 包的 i18n 加载器配置
 */
export const loginI18nLoaders: LocaleLoaders = {
  [I18nLanguage.en]: () => import('./locales/en.json'),
  [I18nLanguage.ja]: () => import('./locales/ja.json'),
  [I18nLanguage.de]: () => import('./locales/de.json'),
  [I18nLanguage.fr]: () => import('./locales/fr.json'),
  [I18nLanguage.es]: () => import('./locales/es.json'),
  [I18nLanguage.it]: () => import('./locales/it.json'),
  [I18nLanguage.nl]: () => import('./locales/nl.json'),
  [I18nLanguage.tr]: () => import('./locales/tr.json'),
  [I18nLanguage.zhCN]: () => import('./locales/zh-cn.json'),
  [I18nLanguage.zhHK]: () => import('./locales/zh-hk.json'),
  [I18nLanguage.ptPT]: () => import('./locales/pt-pt.json'),
  [I18nLanguage.ptBR]: () => import('./locales/pt-br.json'),
  [I18nLanguage.vi]: () => import('./locales/vi.json'),
};
